import { CountryCode } from '@src/common/auth';
import type { Alpha3Code } from '@src/domains/customers/types/auth';

export function isBuyerForeign(countryCode?: Alpha3Code | null): boolean {
  return countryCode !== CountryCode.BRAZIL;
}
